import React, { useEffect } from 'react';
import '../CareersStyles/CareersMain.css';

const CareersMain = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const tags = ['React', 'Node.js', 'Mobile Apps', 'Billing Systems', 'UI/UX Design', 'Cloud'];

  return (
    <section className="careers-hero">
      <div className="careers-hero-inner">
        <div className="careers-hero-content" data-animate="slideInLeft">
          <span className="careers-badge">We're Hiring</span>
          <h1 className="careers-hero-title">
            Build the Future
            <span className="careers-hero-highlight"> With Us</span>
          </h1>
          <p className="careers-hero-subtitle">
            Join Bellary Info Tech Solutions and be part of a team that's redefining what's possible
            in technology. Explore exciting opportunities across engineering, design, and business.
          </p>
          <div className="careers-tags">
            {tags.map((tag, i) => (
              <span className="careers-tag" key={i}>{tag}</span>
            ))}
          </div>
        </div>

        <div className="careers-hero-visual" data-animate="slideInRight">
          <div className="careers-orbit-wrapper">
            <div className="careers-center-circle">
              <span className="careers-center-main">JOIN</span>
              <span className="careers-center-sub">BITS</span>
            </div>

            <div className="careers-orbit-item orbit-pos-1">
              <i className="bi bi-laptop"></i>
              <span>Dev</span>
            </div>
            <div className="careers-orbit-item orbit-pos-2">
              <i className="bi bi-phone"></i>
              <span>Mobile</span>
            </div>
            <div className="careers-orbit-item orbit-pos-3">
              <i className="bi bi-people-fill"></i>
              <span>Team</span>
            </div>
            <div className="careers-orbit-item orbit-pos-4">
              <i className="bi bi-graph-up-arrow"></i>
              <span>Growth</span>
            </div>

            <div className="careers-orbit-ring ring-inner"></div>
            <div className="careers-orbit-ring ring-outer"></div>
          </div>

          <div className="careers-perks">
            <div className="careers-perk">
              <i className="bi bi-award"></i>
              <span>Competitive Pay</span>
            </div>
            <div className="careers-perk">
              <i className="bi bi-lightning-charge"></i>
              <span>Fast Growth</span>
            </div>
            <div className="careers-perk">
              <i className="bi bi-heart"></i>
              <span>Great Culture</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersMain;
